import { FC, ReactElement } from "react";
import { useSelector } from "../../../hooks";
import { Modal } from "../Modal";
import { Loader } from "../../Loader/Loader";
import { ErrorSnackbar } from "../../ErrorSnackbar/ErrorSnackbar";
import { Button, IButtonProps } from "../../Buttons/Button/Button";

interface IModalConfirmProps {
    icon?: string;
    title: string;
    message: ReactElement | string;
    buttonYes: IButtonProps;
    buttonNo: IButtonProps;
}

export const ModalConfirm: FC<IModalConfirmProps> = ({ icon, title, message, buttonYes, buttonNo }) => {
    const { loading, error } = useSelector(store => store.user.info);

    return (
        <>
            <Modal
                name='ModalConfirm'
                icon={ icon }
                title={ title }
                message={ message }
                button={
                    [
                        <Button {...buttonYes} />,
                        <Button {...buttonNo} />
                    ]
                }
            />

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}